import React, { useState, useEffect } from 'react';
import { Typography, Button, Box } from '@mui/material';
import Popper from '@mui/material/Popper';
import Grid from '@material-ui/core/Grid';
import FilterListIcon from '@mui/icons-material/FilterList';
import ForecastDrvDateRangePicker from './ForecastDrvDateRangePicker';

const ForecastDrvFilter = ({
    handleFilter,
    startDate,
    endDate,
    minDate,
    maxDate,
    disabled,
    isOpen,
    onClose,
    onOpen,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [pendingStart, setPendingStart] = useState(startDate ?? null);
    const [pendingEnd, setPendingEnd] = useState(endDate ?? null);

    // Re-sync the picker's pending selection with the parent's applied
    // filter every time the popper is reopened (or the applied filter
    // changes from outside, e.g. a Clear).
    useEffect(() => {
        setPendingStart(startDate ?? null);
        setPendingEnd(endDate ?? null);
    }, [startDate, endDate, isOpen]);

    const canBeOpen = isOpen && Boolean(anchorEl);
    const id = canBeOpen ? 'forecast-filter-popper' : undefined;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        if (isOpen) {
            onClose();
        } else {
            onOpen();
        }
    };

    const handleRangeChange = ({ startDate: newStart, endDate: newEnd }) => {
        setPendingStart(newStart);
        setPendingEnd(newEnd);
    };

    const handleSearchClick = () => {
        if (!pendingStart || !pendingEnd) return;
        try {
            handleFilter({ StartDate: pendingStart, EndDate: pendingEnd });
            onClose();
        } catch (error) {
            console.error(error);
        }
    };

    const handleCancelClick = () => {
        onClose();
    };

    return (
        <>
            <Button
                className='Filter'
                type="button"
                variant="contained"
                color="primary"
                aria-describedby={id}
                onClick={handleClick}
                disabled={disabled}
            >
                <FilterListIcon />Filter
            </Button>

            <Popper id={id} open={canBeOpen} anchorEl={anchorEl} className="Filtercontainer" sx={{ position: "relative", zIndex: 901 }}>
                <Box sx={{ border: 1, p: 1, bgcolor: 'background.paper' }} className="Filtercontainerinner Border">
                    <Box className='Registrationcontainer marketerFiltercontainer'>
                        <Typography component="div" className='userprofilelist'>
                            <Grid container direction="row" spacing={{ xs: 2, md: 3 }}>
                                <Grid item xs={12} sm={6} md={6}>
                                    <Typography variant="h2" className='userprofilelistcontent'>
                                        DRV Forecast
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Typography>

                        <ForecastDrvDateRangePicker
                            startDate={pendingStart}
                            endDate={pendingEnd}
                            label="Select Date Range"
                            onDateRangeChange={handleRangeChange}
                            clearIncompleteOnBlur
                            requiredErrorMessage="Please select both a start and end date."
                        />

                        <Typography component="div" className="CreateMarketerbutton">
                            <Button
                                type="button"
                                variant="contained"
                                className='submitbutton'
                                color="primary"
                                disabled={!pendingStart || !pendingEnd}
                                onClick={handleSearchClick}
                            >
                                Search
                            </Button>
                            <Button
                                variant="contained"
                                color="red"
                                className="cancelbutton"
                                onClick={handleCancelClick}
                            >
                                Cancel
                            </Button>
                        </Typography>
                    </Box>
                </Box>
            </Popper>
        </>
    );
};

export default ForecastDrvFilter;
